// Coming from https://github.com/GoogleChromeLabs/web-push-codelab/blob/master/app/scripts/main.js guide on web push
export const urlB64ToUint8Array = function(base64String) {
    const padding = '='.repeat((4 - base64String.length % 4) % 4);
    const base64 = (base64String + padding)
      .replace(/\-/g, '+')
      .replace(/_/g, '/');
  
    const rawData = window.atob(base64);
    const outputArray = new Uint8Array(rawData.length);
  
    for (let i = 0; i < rawData.length; ++i) {
      outputArray[i] = rawData.charCodeAt(i);
    }
    return outputArray;
}


// WEBPACK FOOTER //
// ./src/scripts/utils/ByteArrayConversionHelper.js